export function getBreakpoint(width, theme) {
    if (theme.breakpoint_xs > width) return 'xs';
    if (theme.breakpoint_sm > width) return 'sm';
    if (theme.breakpoint_md > width) return 'md';
    if (theme.breakpoint_lg > width) return 'lg';
    return 'xl';
}
